import React, { useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa6";
import { MdSaveAlt } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { useDispatch } from "react-redux";
import { creatTypeFieldValueAction } from "../../Actions/TypeFieldAction/TypeFieldAction";

const TypeFieldDropdownModal = ({ closeModal, typeFieldId }) => {
  const [valueDropdown, setValueDropdown] = useState([]);
  const dispatch = useDispatch();
  const handleAdd = (event) => {
    event.preventDefault();
    setValueDropdown([...valueDropdown, [""]]);
  };
  const handleValueDropdownChange = (e, index) => {
    const newValue = [...valueDropdown];
    newValue[index] = e.target.value;
    setValueDropdown(newValue);
  };
  const handleRemoveInput = (event, index) => {
    event.preventDefault();
    const removeInput = [...valueDropdown];
    removeInput.splice(index, 1);
    setValueDropdown(removeInput);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(creatTypeFieldValueAction(typeFieldId, valueDropdown));
    closeModal();
  };
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-container">
          <div className="modal-header ">
            <p
              className="cursor-pointer text-xl text-red-500"
              onClick={closeModal}
            >
              <RxCross2 />
            </p>
          </div>
          <div className="w-full flex justify-end items-center">
            <button className="btn-info" onClick={handleAdd}>
              <FaPlus />
            </button>
          </div>
          <form action="">
            {valueDropdown.map((dropdown, index) => {
              return (
                <div className="flex gap-2 items-center mt-2" key={index}>
                  <input
                    type="text"
                    placeholder="value"
                    className="input p-1 mt-1.5"
                    value={dropdown || ""}
                    onChange={(e) => handleValueDropdownChange(e, index)}
                    key={index}
                  />
                  <div className="">
                    <button
                      onClick={(e) => {
                        handleRemoveInput(e, index);
                      }}
                      className="btn-danger "
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              );
            })}

            <button
              onClick={handleSubmit}
              className="btn-primary flex gap-2 items-center mt-2"
            >
              Save <MdSaveAlt />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TypeFieldDropdownModal;
